import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { hotComics, newComics } from '@/mocks/home';

interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  chapters: number;
  rating: number;
  isHot: boolean;
  isNew: boolean;
}

function ComicCard({ comic }: { comic: Comic }) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${comic.id}`}
      className="flex-shrink-0 w-[240px] md:w-[260px] group cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="relative w-full aspect-[5/7] overflow-hidden">
          <img
            src={comic.cover}
            alt={comic.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          {comic.isHot && (
            <span className="absolute top-2.5 left-2.5 px-2.5 py-0.5 bg-primary-500 text-background-50 text-xs font-bold rounded-full">
              {t('common:hotTag')}
            </span>
          )}
          {comic.isNew && (
            <span className="absolute top-2.5 left-2.5 px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-bold rounded-full">
              {t('common:newTag')}
            </span>
          )}
          <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
          <div className="absolute bottom-3 left-3 right-3">
            <div className="flex items-center gap-1 text-background-50 text-xs">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              <span>{comic.rating}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 px-1">
        <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">
          {comic.author} · {comic.chapters}{t('common:chapters')}
        </p>
      </div>
    </Link>
  );
}

export function HotUpdates() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {t('common:hotRanking')}
            </h2>
            <p className="text-sm text-foreground-500 mt-1">本周最受欢迎的热门韩漫推荐</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('common:viewAll')}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
          {hotComics.map((comic) => (
            <div key={comic.id} style={{ scrollSnapAlign: 'start' }}>
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function LatestUpdates() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {t('common:latestUpdate')}
            </h2>
            <p className="text-sm text-foreground-500 mt-1">刚刚更新的最新韩漫章节</p>
          </div>
          <Link
            to="/category/school"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('common:viewAll')}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="flex gap-4 md:gap-5 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollSnapType: 'x mandatory' }}>
          {newComics.map((comic) => (
            <div key={comic.id} style={{ scrollSnapAlign: 'start' }}>
              <ComicCard comic={comic} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}